import { getStartDateTime } from 'features/daily-plan/components/shared/CreationTaskDrawer';

import { RESCHEDULE_MODES } from './RescheduleActionsDialog.constants';

export const prepareDataToSend = ({ selectedItems, formValues, rescheduleMode }) => {
  if (!selectedItems || !Array.isArray(selectedItems)) return null;

  const taskIds = selectedItems.map(item => item.id);

  if (rescheduleMode === RESCHEDULE_MODES.Tomorrow) {
    return {
      taskIds,
      rescheduleForTomorrow: true
    };
  }

  return {
    taskIds,
    startDatetime: getStartDateTime(formValues)
  };
};
